// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth, setPersistence, browserLocalPersistence } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyCOW3V3UB_Ao5Z9mPZCa1SzbyLPpWioQ9Y",
  authDomain: "www.prepkind.com",
  projectId: "interview-bot-dev-434810",
  storageBucket: "interview-bot-dev-434810.appspot.com",
  messagingSenderId: "1053915770459",
  appId: "1:1053915770459:web:cbd702d94f895237c2597e",
  measurementId: "G-EPYN2K4MC2"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Get Auth instance
const auth = getAuth();

// Set persistence to LOCAL
// This will maintain the user's login state even after browser restart
setPersistence(auth, browserLocalPersistence)
  .catch((error) => {
    console.error("Error setting persistence:", error);
  });

export { auth };
export const db = getFirestore(app);
export default app;
